export type Dictionary=Record<string,string>;
export function translateText(text:string,dictionary:Dictionary):string{
  if(typeof text!=='string')return text;
  if(dictionary[text]!==undefined)return dictionary[text];
  const trimmed=text.trim();if(trimmed!==text&&dictionary[trimmed]!==undefined)return text.replace(trimmed,dictionary[trimmed]);
  const t=(s:string)=>dictionary[s]||s;
  const patterns:[RegExp,(...groups:string[])=>string][]=[
    [/^You need (\d+) (food|wood|gold|ore)\.$/,(n,r)=>`Il vous faut ${n} ${t(r)}.`],
    [/^(Gained|Lost) (\d+) (food|wood|gold|ore|happiness)\.$/,(verb,n,r)=>`${verb==='Gained'?'Gain':'Perte'} de ${n} ${t(r)}.`],
    [/^Gained (.+)\.$/,name=>`Vous obtenez : ${t(name)}.`],
    [/^Earned (.+)\.$/,name=>`Jalon obtenu : ${t(name)}.`],
    [/^Placed (.+)\.$/,name=>`Autocollant posé : ${t(name)}.`],
    [/^Removed (.+)\.$/,name=>`Retiré : ${t(name)}.`],
    [/^Added (.+) to (.+)\.$/,(a,b)=>`${t(a)} ajouté à ${t(b)}.`],
    [/^(.+) joined the village\.$/,name=>`${name} rejoint le village.`],
    [/^(.+) left the table\.$/,name=>`${name} quitte la table.`],
    [/^(.+)'s turn\.$/,name=>`Au tour de ${name}.`],
    [/^Welcome to (.+)\.$/,name=>`Bienvenue à ${name}.`],
    [/^The residents named the village (.+)\.$/,name=>`Les habitants ont nommé le village ${name}.`],
    [/^Updated (heart|progress|upset|gift) marker\.$/,kind=>`Marqueur ${t(kind)} mis à jour.`],
    [/^Year (\d+) is complete\.$/,n=>`L’année ${n} est terminée.`],
    [/^Who will take the first turn of year (\d+)\?$/,n=>`Qui jouera en premier pour l’année ${n} ?`],
    [/^Read ([\d.]+)$/,id=>`Lire ${id}`],
    [/^Research ([\d.]+)$/,id=>`Faire des recherches : ${id}`],
    [/^Explore (.+)$/,id=>`Explorer ${id}`],
    [/^Rolled (\d+)(?: \+ (\d+))?\.$/,(n,b)=>`Résultat du dé : ${n}${b?' + '+b:''}.`],
    [/^Fishing die: (\d+)\.$/,n=>`Dé de pêche : ${n}.`],
    [/^The die rolled (\d+)\.$/,n=>`Le dé donne ${n}.`],
    [/^You rolled (\d+)\. You may reroll once\.$/,n=>`Le dé donne ${n}. Vous pouvez le relancer une fois.`],
    [/^Reel in \((\d+) food\)$/,n=>`Ramener le poisson (${n} nourriture)`],
    [/^Reel with (\d+)$/,n=>`Ramener avec un résultat de ${n}`],
    [/^(\d+) food is on your fishing card\. Keep fishing, or reel in\?$/,n=>`Votre carte de pêche contient ${n} nourriture. Continuer à pêcher ou ramener le poisson ?`],
    [/^Trade (\d+) (food|wood|gold|ore) for (\d+) (food|wood|gold|ore)$/,(a,r,b,q)=>`Échanger ${a} ${t(r)} contre ${b} ${t(q)}`],
    [/^Match (.+) bird$/,slot=>`Trouver l’oiseau ${t(slot)}`],
    [/^Caught (.+?)( for the first time)?\.$/,(name,first)=>`Poisson pêché : ${t(name)}${first?' pour la première fois':''}.`],
    [/^Completed (\d+) village goals\.$/,n=>`${n} objectifs du village remplis.`],
    [/^(.+) will begin the story\.$/,name=>`${name} commencera l’histoire.`],
    [/^(.+) is choosing\.$/,name=>`${name} fait son choix.`],
    [/^(.+) is choosing an action\.$/,name=>`${name} choisit une action.`],
    [/^(.+) is finding just the right spot\.$/,name=>`${name} cherche le bon emplacement.`],
    [/^(.+) is telling this part of the story\.$/,name=>`${name} raconte cette partie de l’histoire.`],
    [/^(.+) now has (\d+) residents and (\d+) happiness\.$/,(name,n,h)=>`${name} compte maintenant ${n} habitants et ${h} bonheur.`],
    [/^Pick up (.+)$/,name=>`Prendre : ${t(name)}`],
    [/^Choose flower sticker (\d+)$/,n=>`Choisir l’autocollant de fleurs ${n}`],
    [/^Flower sticker (\d+)$/,n=>`Autocollant de fleurs ${n}`],
    [/^Language strip (\d+)$/,n=>`Bande de langage ${n}`],
    [/^(.+) language space$/,slot=>`Emplacement de langage ${t(slot)}`],
    [/^(\d+) \/ 4 stickers placed\. (.+)$/,(n,rest)=>`${n} / 4 autocollants posés. ${t(rest)}`]
  ];
  for(const[pattern,replace]of patterns){const match=text.match(pattern);if(match)return replace(...match.slice(1));}
  return text;
}
export function translateDisplay<T>(value:T,dictionary:Dictionary):T{
  function walk(v:any,key=''):any{if(typeof v==='string')return ['text','label','title','name','reason','closing','endOfYearText'].includes(key)?translateText(v,dictionary):v;if(Array.isArray(v))return v.map(x=>walk(x));if(!v||typeof v!=='object')return v;return Object.fromEntries(Object.entries(v).map(([k,x])=>[k,['players','data','variantNames','variantMetadata','tags'].includes(k)?x:walk(x,k)]));}
  return walk(value);
}
